import React from "react";
import { Component, createRef } from 'react';
import { Row, Col, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import DateBox from 'devextreme-react/date-box';
import { Template } from 'devextreme-react/core/template';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { locale } from 'devextreme/localization';
import { DataGrid, Column, Paging, Sorting, Scrolling, Pager } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import ChatsService from 'src/controllers/ChatController';
import InteractionMessagesModal from 'src/components/misc/interactionmessagesmodal';
import InteractionMailModal from 'src/components/misc/interactionMailModal';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Toastr from 'src/components/utils/toastr';
import Contact from 'src/components/contacts/contact';

class SearchInbox extends Component {

    constructor(props) {
        super(props)
        locale(navigator.language);
        this.state = {
            loading: false,
            from: "",
            to: "",
            startDate: new Date(),
            endDate: new Date(),
            channel: "",
            channels: [
                "all2",
                "fidelity",
                "facebook",
                "instagram",
                "rainbow",
                "sms",
                "telegram",
                "twitter",
                "whatsapp",
                "mail"
            ],
            filters: [
                { id: 1, name: "all2" },
                { id: 2, name: "alloutgoing" },
                { id: 3, name: "myinteractions" },
                { id: 4, name: "allmyinteractions" },
                { id: 5, name: "newinteractions" },
                { id: 6, name: "pendinginteractions" },
                { id: 7, name: "closedinteractions" },
                { id: 8, name: "outgoinginteractions" }
            ],
            filter: 1,
            agents: [],
            groups: [],
            userId: -1,
            groupId: -1,
            subject: "",
            body: "",
            reference: "",
            isSearchClicked: false,
            data: [],
            count: 0,
            showInteraction: false,
            interaction: null,
            showInteractionMail: false,
            isSearchAll: true,
            isAnyAgentOnMyGroups: false,
            showContactModal: false,
            bookId: null
        };

        this.dataSource = new CustomStore({
            key: "id",
            load: (loadOptions) => {

                let ret = { data: [], totalCount: 0 };

                if (this.state.isSearchClicked) {



                    const skip = Math.floor(loadOptions.skip / loadOptions.take);
                    const take = loadOptions.take;
                    let sortColumn = "date";
                    let sortOrder = "asc";

                    if (loadOptions.sort && loadOptions.sort.length > 0) {
                        sortColumn = loadOptions.sort[0].selector;
                        sortOrder = loadOptions.sort[0].desc ? "desc" : "asc";
                    }
                    return new Promise((resolve, reject) => {
                        ChatsService.searchInteractions({
                            skip,
                            take,
                            sortColumn,
                            sortOrder,
                            from: this.state.from,
                            to: this.state.to,
                            startDate: this.state.startDate,
                            endDate: this.state.endDate,
                            channel: this.state.channel,
                            userId: this.state.userId,
                            groupId: this.state.groupId,
                            subject: this.state.subject,
                            body: this.state.body,
                            reference: this.state.reference,
                            filter: this.state.filter,
                            agentId: this.props.userId,
                            tenantId: this.props.tenantId

                        }, (result) => {

                            if (result?.data) {
                                ret = {
                                    data: result?.data?.items || [],
                                    totalCount: result?.data?.totalCount || 0
                                };
                            }

                            resolve(ret);
                        }, (error) => reject(error));
                    });
                }

                return Promise.resolve(ret);
            }

        });

        this.agentChange = this.agentChange.bind(this);
        this.groupChange = this.groupChange.bind(this);
        this.changeChannel = this.changeChannel.bind(this);
        this.startDateChange = this.startDateChange.bind(this);
        this.endDateChange = this.endDateChange.bind(this);
        this.setFrom = this.setFrom.bind(this);
        this.setTo = this.setTo.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.setSubject = this.setSubject.bind(this);
        this.setBody = this.setBody.bind(this);
        this.setReference = this.setReference.bind(this);
        this.searchClick = this.searchClick.bind(this);
        this.interactionMailClick = this.interactionMailClick.bind(this);
        this.interactionClick = this.interactionClick.bind(this);
        this.toggleInteraction = this.toggleInteraction.bind(this);
        this.toggleInteractionMail = this.toggleInteractionMail.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.transferCell = this.transferCell.bind(this);
        this.toggleContactModal = this.toggleContactModal.bind(this);
        this.transferError = this.transferError.bind(this);
        ChatsService.registerTransferError(this.transferError);
        this.toastrRef = createRef();
    }

    componentDidMount() {

        ChatsService.isSearchAll(this.props.tenantId, res => {
            ChatsService.isAnyAgentOnMyGroups(this.props.tenantId, resAnyAgtInMyGrps => {
                let filter = 1;
                let userId = -1;
                let filters = [
                    { id: 1, name: "all2" },
                    { id: 3, name: "myinteractions" },
                    { id: 4, name: "allmyinteractions" },
                    { id: 5, name: "newinteractions" },
                    { id: 6, name: "pendinginteractions" },
                    { id: 7, name: "closedinteractions" },
                    { id: 8, name: "outgoinginteractions" },
                    { id: 2, name: "alloutgoing" }
                ];

                if (!res.data) {
                    filter = 3;
                    userId = this.props.userId;
                    filters = [
                        { id: 3, name: "myinteractions" },
                        { id: 4, name: "allmyinteractions" },
                        { id: 5, name: "newinteractions" },
                        { id: 6, name: "pendinginteractions" },
                        { id: 7, name: "closedinteractions" },
                        { id: 8, name: "outgoinginteractions" },
                        { id: 2, name: "alloutgoing" }
                    ];
                }

                if (!res.data) {
                    ChatsService.getUsers(this.props.userId, agents => {

                        let agentsList = [{
                            userId: -1,
                            name: this.props.t("all2")
                        }];

                        if (agents.data != null && agents.data.length > 0)
                            agentsList = agentsList.concat(agents.data);

                        ChatsService.getGroups(this.props.userId, groupsRes => {
                            var groups = [{ id: -1, name: this.props.t("all2") }];
                            if (groupsRes && groupsRes.length > 0) {
                                groups = groups.concat(groupsRes);
                            }

                            this.setState({
                                groups: groups,
                                agents: agentsList,
                                isSearchAll: res.data,
                                filters: filters,
                                filter: filter,
                                userId: userId,
                                isAnyAgentOnMyGroups: resAnyAgtInMyGrps.data
                            });

                        });
                    });
                } else {
                    ChatsService.getUserTenantAgents(this.props.userId, agents => {

                        let agentsList = [{
                            userId: -1,
                            name: this.props.t("all2")
                        }];

                        if (agents?.length > 0)
                            agentsList = agentsList.concat(agents);

                        ChatsService.getUserTenantGroups(this.props.userId, groupsRes => {
                            var groups = [{ id: -1, name: this.props.t("all2") }];
                            if (groupsRes?.length > 0) {
                                groups = groups.concat(groupsRes);
                            }

                            this.setState({
                                groups: groups,
                                agents: agentsList,
                                isSearchAll: res.data,
                                filters: filters,
                                filter: filter,
                                userId: userId,
                                isAnyAgentOnMyGroups: resAnyAgtInMyGrps.data
                            });
                        });
                    });
                }
            });
        });
    }

    templateRender() {
        return <FontAwesomeIcon icon={duotone("calendar-day")} />
    }

    setFrom(e) {
        e.preventDefault();
        this.setState({
            from: e.target.value
        });
    }

    setTo(e) {
        e.preventDefault();
        this.setState({
            to: e.target.value
        });
    }

    agentChange = e => {
        e.preventDefault();
        this.setState({
            userId: e.target.value
        });
    };

    groupChange = e => {
        e.preventDefault();
        this.setState({
            groupId: e.target.value
        });
    }

    startDateChange(e) {

        this.setState({
            startDate: e.value
        });

        if (e.value > this.state.endDate) {
            this.setState({
                endDate: e.value
            });
        }
    }

    endDateChange(e) {
        this.setState({
            endDate: e.value
        });
    }

    changeFilter = e => {
        e.preventDefault();
        const filterId = parseInt(e.target.value);
        let userId = -1;

        if ([3, 4, 8].indexOf(filterId) > -1)
            userId = this.props.userId;
        if (5 == filterId) {
            userId = -1
        }
        this.setState({ filter: filterId, userId: userId });
    }

    setSubject(e) {
        e.preventDefault();
        this.setState({
            subject: e.target.value
        });
    }

    setBody(e) {
        e.preventDefault();
        this.setState({
            body: e.target.value
        });
    }

    setReference(e) {
        e.preventDefault();
        this.setState({
            reference: e.target.value
        });
    }

    changeChannel = e => {
        e.preventDefault();
        this.setState({ channel: e.target.value, subject: "", body: "", reference: "" });
    }

    searchClick = () => {

        this.setState({ isSearchClicked: true }, () => {
            if (this.dataGrid) {
                this.dataGrid.instance.pageIndex(0);
                this.dataGrid.instance.refresh();
            }
        });
    };

    channelCell = dataCell => {
        return (<div className={`icon ${dataCell.value.toLowerCase()}`} style={{ "left": "0px" }} ></div>)
    }

    viewChatCell = dataCell => {
        if (dataCell.data.channel === "MAIL") {
            return (
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("viewContent")}
                    </Tooltip>}>
                    <Button variant="light-primary" size='sm'
                        onClick={e => { console.log(dataCell); this.interactionMailClick(dataCell.data.MessageNumber, dataCell.data.Inbox) }}>
                        <FontAwesomeIcon icon={duotone('eye')} /></Button>
                </OverlayTrigger>
            )
        }
        else {
            return (
                (dataCell.value) &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("viewContent")}
                    </Tooltip>}>
                    <Button variant="light-primary" size='sm' onClick={e => { this.interactionClick(dataCell.value, dataCell.data.status) }}><FontAwesomeIcon icon={duotone('eye')} /></Button>
                </OverlayTrigger>
            )
        }
    }

    interactionMailClick = (emailMessageNumber, inbox) => {
        var data = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_faagtinbox=1`

        this.setState({ emailMessageNumber: emailMessageNumber });
        this.setState({ iframeUrl: url });
        this.toggleInteractionMail();
    }

    interactionClick = (chatGuid, status) => {
        if (status === "queued") {
            ChatsService.getChatByGuid(chatGuid, res => {
                let data = res.data;
                data.channel = data.type;
                this.setState({
                    interaction: data,
                    showInteraction: true
                });
            });
        } else {

            ChatsService.getChat(chatGuid, res => {
                this.setState({
                    interaction: res.data,
                    showInteraction: true
                });
            });
        }
    }

    toggleInteraction = e => {
        this.setState({ showInteraction: !this.state.showInteraction });
    }

    toggleInteractionMail = e => {
        console.log("interactionMailClick");
        this.setState({ showInteractionMail: !this.state.showInteractionMail });
    }

    typeCell = dataCell => {
        return (
            <>

                {
                    (dataCell.value !== 'incoming') &&
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("outgoing")}
                        </Tooltip>}>
                        <div className={`text-primary text-center`}  >
                            <FontAwesomeIcon className='primary' size='2x' icon={duotone('arrow-up-right')} />
                        </div>
                    </OverlayTrigger>

                }
                {

                    (dataCell.value === 'incoming') &&
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("incoming")}
                        </Tooltip>}>
                        <div className={`text-success text-center`}  >
                            <FontAwesomeIcon className='success' size='2x' icon={duotone('arrow-down-left')} />
                        </div>
                    </OverlayTrigger>
                }

            </>
        )
    }

    missedCell = dataCell => {
        return (
            <>
                {
                    (dataCell.value === 1) &&
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("missed2")}
                        </Tooltip>}>
                        <div className={`${dataCell.value ? 'text-danger' : 'text-primary'} text-center`}  >
                            <FontAwesomeIcon className='danger' size='lg' icon={solid('x')} />
                        </div>
                    </OverlayTrigger>
                }
            </>
        )
    }

    statusCell = dataCell => {
        return (<>

            {
                (dataCell.value === 'agent') &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("withagent")}
                    </Tooltip>}>
                    <div className={`text-center`}  >
                        <FontAwesomeIcon className='text-primary' size='lg' icon={faUser} />
                    </div>

                </OverlayTrigger>
            }
            {
                (dataCell.value === 'queued') &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("inqueue")}
                    </Tooltip>}>
                    <div className={`text-center`}> <FontAwesomeIcon className='text-warning' size='lg' icon={duotone("message-plus")} /></div>
                </OverlayTrigger>

            }
            {
                (dataCell.value === 'postponed') &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("postponed")}
                    </Tooltip>}>
                    <div className={`text-center`}>
                        <FontAwesomeIcon className='text-danger' size='lg' icon={duotone('clock-rotate-left')} />
                    </div>
                </OverlayTrigger>

            }
            {
                (dataCell.value === 'closed') &&
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {this.props.t("processed")}
                    </Tooltip>}>
                    <div className={`text-center`}>
                        <FontAwesomeIcon className='text-success' size='lg' icon={duotone('check')} />
                    </div>
                </OverlayTrigger>
            }

        </>)
    }

    handleSend = data => {
        ChatsService.transferChat(this.props.userId, null, data.guid, null, () => {
            setTimeout(() => {
                this.searchClick();
            }, 100);
        });
    }

    transferCell = cellData => {
        return (
            <Button variant="light-primary" size="xs" onClick={e => this.handleSend(cellData.data)} title={this.props.t("transfertome")}>
                <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
            </Button>
        );
    }

    transferError = message => {

        this.toastrRef.current.setType("error");
        this.toastrRef.current.setMessage(`${this.props.t("transfererror")}
         ${this.props.t("from")}  ${message.from}
         ${this.props.t("to")} ${message.to}`);
        this.toastrRef.current.show();

    }
    viewContact = dataCell => {
        return (
            (dataCell.data && dataCell.data.bookId) &&
            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {this.props.t("contact")}
                </Tooltip>}>
                <Button variant="light-primary" size='sm' onClick={e => this.interactionContactClick(dataCell.data.bookId)}><FontAwesomeIcon icon={duotone('address-book')} /></Button>
            </OverlayTrigger>
        )
    }

    interactionContactClick = (bookId) => {
        this.setState({ bookId: bookId });
        this.toggleContactModal();
    }

    toggleContactModal() {
        this.setState({ showContactModal: !this.state.showContactModal });
    }

    render() {
        return (
            <Row>
                <Col xs={3} className={`interaction-list`}>
                    <Row>
                        <Col xs={6}>
                            <Form.Group className="mb-4" controlId="sHistoryChannel">
                                <Form.Label>{this.props.t("channel")}</Form.Label>
                                <Form.Select onChange={this.changeChannel} value={this.state.channel}>
                                    {
                                        this.state.channels.map(elem => {
                                            return <option key={elem} value={elem}> {this.props.t(elem)}</option>
                                        })
                                    }
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group className="mb-4" controlId="sfilter">
                                <Form.Label>{this.props.t("filter")}</Form.Label>
                                <Form.Select onChange={this.changeFilter} value={this.state.filter}>
                                    {
                                        this.state.filters.map(f => {
                                            return <option key={f.id} value={f.id}> {this.props.t(f.name)}</option>
                                        })
                                    }
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group controlId="sStartDate">
                                <Form.Label>{this.props.t("startdate")}</Form.Label>
                                <DateBox
                                    value={this.state.startDate}
                                    type="date"
                                    onValueChanged={this.startDateChange}
                                    dropDownButtonTemplate='conditionalIcon'
                                    openOnFieldClick={true}>
                                    <Template name='conditionalIcon' render={this.templateRender} />
                                </DateBox>

                            </Form.Group></Col>
                        <Col xs={6}>
                            <Form.Group controlId="sEndDate">
                                <Form.Label>{this.props.t("enddate")}</Form.Label>
                                <DateBox
                                    value={this.state.endDate}
                                    type="date"
                                    onValueChanged={this.endDateChange}
                                    dropDownButtonTemplate='conditionalIcon'
                                    openOnFieldClick={true}>
                                    <Template name='conditionalIcon' render={this.templateRender} />
                                </DateBox>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group className="mb-4" controlId="sgroups">
                                <Form.Label>{this.props.t("group")}</Form.Label>
                                <Form.Select onChange={this.groupChange} value={this.state.groupId}>
                                    {
                                        this.state.groups.map(elem => {
                                            return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                        })
                                    }
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {
                            (this.state.isSearchAll || this.state.isAnyAgentOnMyGroups) &&
                            <Col xs={6}>
                                <Form.Group className="mb-4" controlId="sagent">
                                    <Form.Label>{this.props.t("agent")}</Form.Label>
                                    <Form.Select onChange={this.agentChange} value={this.state.userId} disabled={[3, 4, 5, 8].indexOf(this.state.filter) > -1}  >
                                        {
                                            this.state.agents.map(elem => {
                                                return <option key={elem.id} value={elem.id} >{elem.name || elem.username}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        }
                        <Col xs={6}>
                            <Form.Group className="mb-4" controlId="sorigin">
                                <Form.Label>{this.props.t("from")}</Form.Label>
                                <Form.Control className='' value={this.state.from} type="text" onChange={this.setFrom}></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group className="mb-4" controlId="sto">
                                <Form.Label>{this.props.t("to")}</Form.Label>
                                <Form.Control className='' value={this.state.to} type="text" onChange={this.setTo}></Form.Control>
                            </Form.Group>
                        </Col>

                        {
                            this.state.channel === "mail" &&
                            <>
                                <Form.Group className="mb-4" controlId="ssubject">
                                    <Form.Label>{this.props.t("subject")}</Form.Label>
                                    <Form.Control className='' value={this.state.subject} type="text" onChange={this.setSubject}></Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="sbody">
                                    <Form.Label>{this.props.t("body")}</Form.Label>
                                    <Form.Control className='' value={this.state.body} type="text" onChange={this.setBody}></Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="sreference">
                                    <Form.Label>{this.props.t("reference")}</Form.Label>
                                    <Form.Control className='' value={this.state.reference} type="text" onChange={this.setReference}></Form.Control>
                                </Form.Group>
                            </>
                        }
                    </Row>
                    <Button className="searchbtn" variant="primary" onClick={this.searchClick}>
                        <FontAwesomeIcon icon={solid("magnifying-glass")} /> {this.props.t("search2")}
                    </Button>
                </Col>
                <Col xs={9} className="interaction-window" style={{ padding: 0 }}>
                    <DataGrid
                        dataSource={this.dataSource}
                        remoteOperations={true}
                        showBorders={false}
                        repaintChangesOnly={true}
                        columnAutoWidth={true}
                        width={"100%"}
                        height={"99%"}
                        allowColumnResizing={true}
                        rowAlternationEnabled={true}
                        ref={(ref) => (this.dataGrid = ref)}>
                        <Column dataField="id" visible={false} showInColumnChooser={false} />
                        <Column dataField="channel" caption={this.props.t("channel")} width={60} cellRender={this.channelCell} alignment="center" />
                        <Column dataField="type" caption={this.props.t("type")} width={60} cellRender={this.typeCell} />
                        <Column dataField="missed" visible={false} cssClass={"align-middle"} caption={this.props.t("missed2")} width={60} cellRender={this.missedCell} />
                        <Column dataField="status" cssClass={"align-middle"} caption={this.props.t("status")} width={60} cellRender={this.statusCell} />
                        <Column dataField="date" caption={this.props.t("datetime")} dataType="datetime" format='dd/MM/yyyy HH:mm:ss' sortOrder="desc" sortIndex={0} width={180} />
                        <Column dataField="from" caption={this.props.t("from")} visible={true} width={180} />
                        <Column dataField="to" caption={this.props.t("to")} visible={true} width={180} />
                        <Column dataField="group" caption={this.props.t("group")} visible={true} width={180} />
                        <Column dataField="agent" caption={this.props.t("agent")} visible={true} width={180} />
                        <Column dataField="subject" caption={this.props.t("subject")} width={180} visible={this.state.channel === "mail"} />
                        <Column dataField="body" caption={this.props.t("body")} width={180} visible={this.state.channel === "mail"} />
                        <Column dataField="reference" caption={this.props.t("reference")} width={180} visible={this.state.channel === "mail"} />
                        <Column cssClass={"align-middle"} dataField="guid" caption={""} width={60} cellRender={this.viewChatCell} allowFiltering={false} alignment="center" />
                        <Column cssClass={"align-middle"} caption={""} width={60} cellRender={this.viewContact} allowFiltering={false} />
                        <Column cssClass={"align-middle"} dataField="transfer" caption={""} showInColumnChooser={false} width={60} cellRender={this.transferCell} allowFiltering={false} alignment="center" visible={this.state.filter === 5 && this.props?.functions?.manageInteractions} />
                        <Sorting mode={"single"} />
                        <Scrolling mode={"standard"} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[5, 9, 12, 15]}
                            showInfo={true}
                            showNavigationButtons={true}
                            infoText={this.props.t("pager")}
                        />
                        <Paging defaultPageSize={12} />
                    </DataGrid>
                </Col>
                <InteractionMailModal show={this.state.showInteractionMail} toggleModal={this.toggleInteractionMail} interaction={this.state.interaction} url={this.state.iframeUrl}></InteractionMailModal>
                <InteractionMessagesModal show={this.state.showInteraction} toggleModal={this.toggleInteraction} interaction={this.state.interaction}></InteractionMessagesModal>
                <Contact show={this.state.showContactModal} toggleModal={this.toggleContactModal} action="editcontact" contactId={this.state.bookId}></Contact>
                <Toastr ref={this.toastrRef} />
            </Row >)
    }

}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        functions: state.agent.functions,
        token: state.agent.monitorToken,
        tenantId: state.agent.tenantId
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(SearchInbox);